<template>
  <div class="lxn-w100">
    <div class="AcRemoteControllerLCD-wrapper-lcd lxn-margin-auto lxn-border-round">
      <div class="AcRemoteControllerLCD-wrapper-mode lxn-float-left lxn-h100">
        <div v-if="modeVisualSettings.show" class="AcRemoteControllerLCD-mode-icon lxn-margin-auto">
          <ButtonIcon :size="40" bgColor="#52636b" :icon="modeVisualSettings.icon" :iconColor="modeVisualSettings.iconColor" :padding="0" />
        </div>
        <div v-if="modeVisualSettings.show" class="AcRemoteControllerLCD-mode-text lxn-w100 lxn-text-en lxn-text-center" :style="modeVisualSettings.textStyle">
          {{modeVisualSettings.text}}
        </div>
      </div>
      <div class="AcRemoteControllerLCD-wrapper-temperature lxn-float-left lxn-h100 lxn-pos-rel">
        <div class="AcRemoteControllerLCD-fullDigit lxn-w100 lxn-text-center lxn-text-7seg lxn-pos-abs">
          88
        </div>
        <div class="AcRemoteControllerLCD-temperature lxn-w100 lxn-text-center lxn-text-7seg lxn-pos-abs">
          {{temperatureText}}
        </div>
      </div>
      <div class="AcRemoteControllerLCD-wrapper-fan lxn-float-left lxn-h100">
        <div v-if="fanVisualSettings.show" class="AcRemoteControllerLCD-fan-icon lxn-margin-auto">
          <ButtonIcon :size="40" bgColor="#52636b" icon="fan" iconColor="#ceaf5c" :padding="0" />
        </div>
        <div v-if="fanVisualSettings.show" class="AcRemoteControllerLCD-fan-text lxn-w100 lxn-text-en lxn-text-center">
          {{fanVisualSettings.text}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'

export default {
  name: 'AcRemoteControllerLCD',
  props: {
    targetFan: String,
    targetTemperature: String,
    targetMode: String
  },
  data: function() {
    return {
    }
  },
  components: {
    ButtonIcon
  },
  computed: {
    modeVisualSettings: function () {
      var icon = '';
      var iconColor = '';
      var show = true;
      var text = '';
      var textStyle = '';
      switch(this.targetMode){
        case "AC_MODE_COOL":
          icon = 'cool';
          iconColor = '#319dde';
          text = 'Cool';
          break;
        case "AC_MODE_HEAT":
          icon = 'heat';
          iconColor = '#ffd400';
          text = 'Heat';
          break;
        case "AC_MODE_FAN":
          icon = 'fan2';
          iconColor = '#9ffdff';
          text = 'Fan';
          break;
        case "AC_MODE_AUTO":
          icon = 'auto';
          iconColor = '#ffffff';
          text = 'Auto';
          break;
        case "AC_MODE_DRY":
          icon = 'dry';
          iconColor = '#e4ff9f';
          text = 'Dry';
          break;
        case "AC_MODE_FEEL":
          icon = 'feel';
          iconColor = '#e4ff9f';
          text = 'feel';
          break;
        default:
          show = false;
      }
      textStyle = 'color: ' + iconColor + ';';
      return {icon: icon, iconColor: iconColor, text: text, textStyle: textStyle, show: show};
    },
    fanVisualSettings: function () {
      var show = true;
      var text = '';
      switch(this.targetFan){
        case "AC_FAN_LOW":
          text = 'Low';
          break;
        case "AC_FAN_MID":
          text = 'Mid';
          break;
        case "AC_FAN_HIGH":
          text = 'High';
          break;
        case "AC_FAN_AUTO":
          text = 'Auto';
          break;
        case "AC_FAN_ULTRA_LOW":
          text = 'Ultra Low';
          break;
        default:
          show = false;
      }
      return {text: text, show: show};
    },
    temperatureText: function () {
      switch(this.targetTemperature){
        case "AC_TEMP_16":
          return "16";
        case "AC_TEMP_17":
          return "17";
        case "AC_TEMP_18":
          return "18";
        case "AC_TEMP_19":
          return "19";
        case "AC_TEMP_20":
          return "20";
        case "AC_TEMP_21":
          return "21";
        case "AC_TEMP_22":
          return "22";
        case "AC_TEMP_23":
          return "23";
        case "AC_TEMP_24":
          return "24";
        case "AC_TEMP_25":
          return "25";
        case "AC_TEMP_26":
          return "26";
        case "AC_TEMP_27":
          return "27";
        case "AC_TEMP_28":
          return "28";
        case "AC_TEMP_29":
          return "29";
        case "AC_TEMP_30":
          return "30";
        case "AC_TEMP_31":
          return "31";
        case "AC_TEMP_32":
          return "32";
        case "AC_TEMP_LOW":
          return "Lo";
        case "AC_TEMP_HIGH":
          return "Hi";
        case "AC_TEMP_MID":
          return "Mi";
        case "AC_TEMP_DRY_7":
          return "07";
        case "AC_TEMP_DRY_6":
          return "06";
        case "AC_TEMP_DRY_5":
          return "05";
        case "AC_TEMP_DRY_4":
          return "04";
        case "AC_TEMP_DRY_3":
          return "03";
        case "AC_TEMP_DRY_2":
          return "02";
        case "AC_TEMP_DRY_1":
          return "01";
        case "AC_TEMP_DRY_N1":
          return "-1";
        case "AC_TEMP_DRY_N2":
          return "-2";
        case "AC_TEMP_DRY_N3":
          return "-3";
        case "AC_TEMP_DRY_N4":
          return "-4";
        case "AC_TEMP_DRY_N5":
          return "-5";
        case "AC_TEMP_DRY_N6":
          return "-6";
        case "AC_TEMP_DRY_N7":
          return "-7";
        case "AC_TEMP_AUTO_1":
          return "01";
        case "AC_TEMP_AUTO_2":
          return "02";
        case "AC_TEMP_AUTO_3":
          return "03";
        case "AC_TEMP_AUTO_N1":
          return "-1";
        case "AC_TEMP_AUTO_N2":
          return "-2";
        case "AC_TEMP_AUTO_N3":
          return "-3";
        default:
          return "";
      }
    },
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .AcRemoteControllerLCD-wrapper-lcd {
    width: calc(100% - 28px);
    height: 100px;
    background-color: #52636b;
    border-style: solid;
    border-width: 4px;
    border-color: #c8c9cb;
  }
  .AcRemoteControllerLCD-wrapper-mode {
    width: 25%;
  }
  .AcRemoteControllerLCD-wrapper-temperature {
    width: 50%;
  }
  .AcRemoteControllerLCD-wrapper-fan {
    width: 25%;
  }
  .AcRemoteControllerLCD-fullDigit {
    top: 0;
    left: 0;
    line-height: 100px;
    color: #6e7c85;
    font-size: 70px;
  }
  .AcRemoteControllerLCD-temperature {
    top: 0;
    left: 0;
    line-height: 100px;
    color: #a1d0ec;
    font-size: 70px;
  }
  .AcRemoteControllerLCD-mode-icon {
    margin-top: 15px;
    width: 40px;
    height: 40px;
  }
  .AcRemoteControllerLCD-mode-text {
    margin-top: 5px;
  }
  .AcRemoteControllerLCD-fan-icon {
    margin-top: 15px;
    width: 40px;
    height: 40px;
  }
  .AcRemoteControllerLCD-fan-text {
    margin-top: 5px;
    color: #ceaf5c;
  }
</style>
